import Lib from 'library'
import axios from 'axios'
import { useEffect, useState, useRef, useCallback } from 'react'
import styles from 'views/setting/index.module.css'
import { Link, Navigate, useNavigate } from 'react-router-dom'
import useApp from 'hooks/useApp'
import layerStyles from 'css/Layer.module.css'
import { NoData, Layer } from 'components'
import { showNoticeLayerState, moreNoticePost, pushDataState } from 'views/setting/states'
import { useRecoilState } from 'recoil'
import Native from 'library/native';
import icon_download from '../../images/icon_download.svg'
// import stylesLayer from "css/Layer.module.css";

const Notice = () => {

	const [showNoticeLayer, setShowNoticeLayer] = useRecoilState(showNoticeLayerState)
	const [morePage, setMorePage] = useRecoilState(moreNoticePost);

	// PUSH
    const [pushData, setPushData] = useRecoilState(pushDataState);    // 푸쉬 데이터

	const App = useApp();
	// const navigate = useNavigate();

	const isLoading = useRef(false)
	const noMore = useRef(false)

	const [data, setData] = useState()
	const [newData, setNewData] = useState()
	const [fixList, setFixList] = useState()
	const [list, setList] = useState()
	const [detailId, setDetailId] = useState()
	const [showDetail, setShowDetail] = useState(false)
	const [rowsPerPage, setRowsPerPage] = useState(10)	//페이지당 로우 수
	const layerWin = useRef()
	const page = useRef(1)

	useEffect(() => {
		if (showNoticeLayer) {
			document.querySelector("nav .active")?.classList.remove("active");
		}
	}, [showNoticeLayer]);

	const getData = (morePage) => {
		if (noMore.current) return
		isLoading.current = true
		if (typeof morePage !== "undefined") page.current = morePage
		Lib.get(`/api/more/cstmr/srvc/ntc/dstnt`, {
			rowsPerPage: rowsPerPage,
			pageNo: typeof morePage !== "undefined" ? morePage : page.current
		}, data => {
			isLoading.current = false
			// setData(setNewList(data))
			if(morePage > 1){
				setNewData(setNewList(data))
				if(newData) {
					if(data.length < rowsPerPage) noMore.current = true
					setData(prevState => [
						...prevState,
						...newData
					]);
				} 
			} else {
				setData(setNewList(data))
				if(data.length < rowsPerPage) noMore.current = true
			}
		})
	}

	const bindScroll = () => {
		const layerWrap = layerWin.current.querySelector(`.${layerStyles.wrap}`)
		const wrapPadding = layerWin.current.querySelector(`#wrapPadding`)
		const screenHeight = window.screen ? window.screen.height : window.innerHeight
		if (layerWrap) {
			layerWrap.addEventListener("scroll", e => {
				if (noMore.current) return
				const scrollTop = layerWrap.scrollTop
				const rect = wrapPadding.getBoundingClientRect()
				const top = rect.top
				const height = rect.height
				if (((height + top) - screenHeight) <= scrollTop) {
					if (!isLoading.current) setMorePage(prevStus => prevStus + 1);
				}
			})
			// if (!isLoading.current && !noMore.current) setMorePage(prevStus => prevStus + 1);
		} 
	}

	useEffect(() => {
		getData(morePage)
	},[morePage]);

	useEffect(() => {
		// PUSH DATA 처리
		if (pushData && pushData.url && showNoticeLayer) {
			const urlArr = (pushData.url).split("/");
			if (urlArr[2] === "notice") {
				if (pushData.no !== "") {
					console.log("상세조회다");
					// 상세조회인 경우,
					onClick(pushData.no);
				} else {
					// 상세조회가 아닌 경우,
					setPushData(null);
				}
			}
		}
	}, [pushData]);

	useEffect(() => {
		console.log("테스트 입니다욤");
		// PUSH DATA 처리
		if (pushData && pushData.url && showNoticeLayer) {
			const urlArr = (pushData.url).split("/");
			if (urlArr[2] === "notice") {
				if (pushData.no !== "") {
					// 상세조회인 경우,
					onClick(pushData.no);
				} else {
					// 상세조회가 아닌 경우,
					setPushData(null);
				}
			}
		}
	}, [showNoticeLayer]);

	const onClick = (id) => {
		console.log("notice onClick event !!!!");
		setDetailId(id)
		setShowDetail(true)
	}

	// useEffect(() => {
	// 	// console.log("effect start")
	// 	if(showNoticeLayer) {
	// 		bindScroll()
	// 		getData(morePage)
	// 	} else if(showNoticeLayer === false){
	// 		setMorePage(1)
	// 	}
	// 	// console.log("effect end")

	// }, [showNoticeLayer])

	//NEW 표시 기간조회 게시글 등록 당일부터(노출일자) 익일 까지
	const setNewList = (list) => {
		const now = new Date()
		return list.filter(item => {
			const start = Lib.ChanageNewDate(`${item.notiStDe?item.notiStDe.replace(/\.|-/g, "/"):""} ${item.notiStTm ?? "00:00:00"}`)
			const end = Lib.ChanageNewDate(`${item.notiEdDe?item.notiEdDe.replace(/\.|-/g, "/"):""} ${item.notiEdTm ?? "00:00:00"}`)
			if (start.getTime() < now.getTime() && now.getTime() < (start.getTime() + (2 * 24 * 60 * 60 * 1000))) {
				item.new = true
			} else {
				item.new = false
			}

			if (start < now && now < end) {
				return true
			} else {
				return false
			}
		})
	}



	return (
		<Layer show={showNoticeLayer} closeLayer={() => setShowNoticeLayer(false)} ref={layerWin}>
				<div className="page">
					<div className="padding" id="wrapPadding">
						<div className={styles.title}>공지사항</div>
						{/* 데이터 있을 때 */}
						<ul className={`${styles["notice-list"]} mt_20`}>
							{data ?
								data.length ?
									data.map((item, index) => {
										return (
											<li key={index}
												onClick={() => onClick(item.sno)}
											>
												<div className={styles.title}>{item.fixYn === "Y" && <i className={styles.important}>중요</i>}<p className="ellipsis">{item.notiTitle}</p></div>
												<span className={styles.date}>{item.notiStDe.split(" ")[0]}
													{item.new === true &&
														<span className={`${styles.badge} ml_5`}>N</span>
													}
												</span>
												{/* <span className={styles.date}>{item.regDt.split(" ")[0]}<span className={`${styles.badge} ml_5`}>N</span></span> */}
											</li>
										)
									})
									:
									<div className="center-cont">
										<i className="icon icon_no_data" />
										<p className="mt_20">등록된 공지사항이 없어요.</p>
									</div>
								:
								<div className="center-cont">
									<i className="icon icon_no_data" />
									<p className="mt_20">데이터를 조회중입니다.</p>
								</div>
							}
							{/* 데이터 받기 전 */}
							{!data &&
								<NoData text="공지사항 조회중." />
							}
						</ul>
					</div>
					<NoticeDetail show={showDetail} closeLayer={setShowDetail} id={detailId} />
				</div>
			</Layer>
	)
}

//공지사항 상세 화면
const NoticeDetail = (props) => {
	// PUSH
	const [pushData, setPushData] = useRecoilState(pushDataState);    // 푸쉬 데이터
	const [data, setData] = useState()

	const getDetail = () => {
		Lib.get(`/api/more/cstmr/srvc/ntc/${props.id}`, data => {
			console.log('data ' + JSON.stringify(data));
			setData(data)
		})
	}

	useEffect(() => {
		if (props.show) {
			getDetail();

			if (pushData && pushData.url) {
				const urlArr = (pushData.url).split("/");
				if (urlArr[2] === "notice") {
					if (pushData.no !== "") {
						// 상세조회인 경우,
						setPushData(null);
					}
				}
			}
		}
		return () => setData()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.show])

	// useEffect(() => {
	// 	// PUSH DATA 처리
	// 	if (pushData && props.show) {
	// 		const urlArr = (pushData.url).split("/");
	// 		if (urlArr[2] === "notice") {
	// 			if (pushData.no !== "") {
	// 				// 상세조회인 경우,
	// 				setPushData(null);
	// 			}
	// 		}
	// 	}
	// }, []);

	// 다운로드
    const downloadFile = async (fileId, fileNm) => {
		let ext = "";
		let mimeType = "";

        if (fileNm && (fileNm.split(".")).length > 0) {
            ext = (fileNm.split("."))[1];
			mimeType = `application/${ext.toLowerCase()}`
        }

		console.log("fileNm : " + fileNm);
		console.log("mimeType : " + mimeType);
		
		if(Native.getUserAgent() === "android") {
			Native.execute('AppManager', 'downloadFile', undefined, { url: window.location.protocol + "//" + window.location.host+'/api/comm/download/' + fileId, filename:fileNm, mimeType:mimeType});
		} else if(Native.getUserAgent() === "ios") {
			Native.execute('AppManager', 'sharePlus', undefined, { type:'url', data:window.location.protocol + "//" + window.location.host +'/api/comm/download/' + fileId, filename:fileNm});
		}

		// const options = {
		// 	method: "GET",
		// 	responseType: "arraybuffer",
		// 	headers: {},
		// 	data: {},
		// 	url: `/api/comm/download/${fileId}`,
		// 	maxContentLength: Infinity,
		// 	maxBodyLength: Infinity,
		// 	timeout: 60 * 30 * 1000,
		// 	cache: "no-cache"
		// };

		// await axios(options)
		// .then(function(response) {
		// 	console.log(response);
		// 	const url = window.URL.createObjectURL(
		// 		new Blob([response.data], {type: `${mimeType}`})
		// 	);
		// 	Lib.reqBlobFileDownlaod(url,fileNm);
		// 	setTimeout(() => {
		// 		window.URL.revokeObjectURL(url);
		// 	}, 1000);
		// })
		// .then(function() {
		// 	console.log("success");
		// })
		// .catch(function(error) {
		// 	console.log("fail");
		// });
    }

	return (
		<Layer {...props} >
			{data ?
				<div className="page padding">
					<div className={styles["detail-title"]}>
						<p>{data.notiTitle}</p>
						<span>{data.notiStDe}</span>
					</div>
					<hr className="my_30" />
					<div className={styles["detail-content"]}>
						<p className="section-cont" dangerouslySetInnerHTML={{ __html: data.notiConts }}></p>
						{/*	[공지상세에서 첨부이미지 삭제. 20230128]
						{
							data.atchFileList &&
							data.atchFileList.length && data.atchFileList.map((img, index) => {
								return (
									<div key={index} className="img-box mt_20">
										<img src={`/api/comm/showImage/${img.sstmFileId}`} className="bbs_img" alt={img.orignFileNm} />
									</div>
								)
							})
						}
						*/}
						{data.atchFileList && 
							<>
								<hr className="my_30" />
									<div className="img-box mt_20 mb_20">
										{
											data.atchFileList.map((img, index) => {
												return (
													<div key={index}>
														<i className='icon icon_download' key={"icon_"+index}/>
														<a type="button" className="btn" key={"file_"+index} onClick={() => downloadFile(img.sstmFileId, img.orignFileNm)}>
															{img.orignFileNm}
														</a>
													</div>
												)
											})
										}
									</div>	
								<hr className="my_30" />
							</>
						}
						
					</div>
				</div>
				:
				<div className="page padding">
					<div className="skeleton" style={{ width: "20rem", height: "2rem" }}></div>
					<div className="skeleton mt_10" style={{ width: "10rem", height: "2rem" }}></div>
					<hr className="my_20" />
					<p className="skeleton" style={{ height: "15rem" }} />
					<p className="skeleton mt_20" style={{ height: "8rem" }} />
					<p className="skeleton mt_20" style={{ height: "8rem" }} />
				</div>
			}
		</Layer>
	)
}

export default Notice
